import { cn } from '@kar-dmp/ignite';
import SvgBackground from './SvgBackground';

const BackgroundCircles = ({ children, authenticated, isLoginPage }) => {
	const className = cn(
		'relative grid flex-1 rounded-2xl bg-[#f1fcff]',
		!isLoginPage && 'md:mx-4',
		authenticated ? 'min-h-[calc(100vh-57px)]' : 'min-h-[calc(100vh-113px)]',
		'max-md:min-h-[calc(100vh-72px)]',
	);

	return (
		<div className={className}>
			<SvgBackground />
			{children}
		</div>
	);
};

export default BackgroundCircles;
